<template>
  <div class="container">
    <h2 class="mb-5">Compositions</h2>
    <div class="text-right mb-3">
        <base-button
            radius="tr"
            component-class="green filled"
            @click.native="add"
        >
            <i class="fas fa-plus-circle mr-3"></i> ADD
        </base-button>
    </div>
    <async-wait
      :init="{dispatch: 'userCompositions/getCompositions', getter: 'userCompositions/data'}"
    >
      <table class="table table-bordered">
            <thead>
                <tr>
                    <th>Name</th>
                    <th style="width: 130px;">Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="composition in compositions" :key="composition.id">
                    <td>
                        <a
                            title="Edit composition"
                            href="javascript:;"
                            @click="edit(composition)"
                        >{{ composition.name }}</a>
                    </td>
                    <td>
                        <span class="action-icon" @click="remove(composition)" title="Remove composition">
                            <i class="far fa-trash-alt"></i>
                        </span>
                    </td>
                </tr>
            </tbody>
      </table>
    </async-wait>

    <base-button radius="bl" component-class="blue" @click.native="$router.push({ name: 'user.dashboard' })">
        <i class="fas fa-arrow-left mr-3"></i> Back
    </base-button>
  </div>
</template>

<script>
    import BaseButton from '@/components/inputs/button/BaseButton';
    import AsyncWait from '@/components/async-wait/AsyncWait';

    export default {
        methods: {
            add() {
                this.$store.dispatch('userCompositions/current', {
                    company_id: null,
                    name: '',
                    additives_percentage: 0,
                    other_percentage: 0,
                    materials: []
                });

                this.$router.push({ name: 'user.composition' });
            },
            edit(composition) {
                const t = deepCopy(composition);
                t.company = this.companies.find(x => t.company_id === x.id);
                t.materials.forEach(e => {
                    e.checked = true;
                });
                this.$store.dispatch('userCompositions/current', t);
                this.$router.push({ name: 'user.composition' });
            },
            remove(composition) {
                this.$store
                    .dispatch('userCompositions/remove', composition.id)
                    .then(() => {
                        this.$store.dispatch('userCompositions/getCompositions');
                    }).catch((error) => {
                        if (error.response.data.errors.length) {
                            this.$snotify.error(error.response.data.errors[0].msg);
                        }
                    });
            },
        },

        data() {
            return {};
        },
        computed: {
            compositions: {
                get() {
                    return this.$store.getters['userCompositions/data'];
                },
                set(value) {
                    this.$store.commit('userCompositions/data', value);
                }
            },
            companies() {
                return this.$store.getters['userCompanies/data'];
            }
        },
        components: {
            'base-button': BaseButton,
            'async-wait': AsyncWait
        }
    };
</script>
